import api from 'data/api';

export const loadTypes = api('GET /api/mobile/finance/lookups/types');
